import { baseOnlyUniqueUrlValidator } from '../utils';
export var onlyUniquePublishedUrlValidator = function (value, validatorProps) {
    var pathPrefixes = validatorProps.pathPrefixes;
    var publishedPathPrefixes = Object.values(pathPrefixes)
        .map(function (_a) {
        var publishedPrefix = _a.publishedPrefix;
        return publishedPrefix;
    })
        .filter(Boolean);
    return baseOnlyUniqueUrlValidator(publishedPathPrefixes)(value, validatorProps.defaultMapping.defaultPublished);
};
//# sourceMappingURL=only-unique-published-url-validator.js.map